import React, { Component } from 'react';
import Heatmap from 'heatmap.js';

class RssiHeatMap extends Component {
  constructor(props) {
    super(props);
    this.heatmapRef = React.createRef();
    this.legendRef = React.createRef();
  }

  componentDidMount() {
    // Create a new heatmap instance
    this.heatmapInstance = Heatmap.create({
      container: this.heatmapRef.current,
      opacity: 0.6,
      blur: 0.85,
      onExtremaChange: function (data) {
        var legendCanvas = document.createElement('canvas');
        legendCanvas.width = 480; 
        legendCanvas.height = 15;
       
        var gradientImg = document.getElementById('gradient');
        var legendCtx = legendCanvas.getContext('2d');
        var gradientCfg = {

          // 0.1: 'rgba(155, 190, 201, 0.5)',
          // 0.4: 'rgba(156, 240, 163, 0.5)',
          // 0.7: 'rgba(238, 247, 111, 0.5)',
          // 1.0: 'rgba(255, 77, 64, 0.5)'
          // 0.1: 'rgb(89, 115, 194)',
          0.1: 'rgb(63, 204, 101)',
          0.3: 'rgb(238, 247, 111)',
          0.45: 'rgb(238, 247, 111)',
          0.95: 'rgb(255, 77, 64)'

        }

        // regenerate gradient image
        var gradient = legendCtx.createLinearGradient(0, 0, 360, 1);
        for (var key in gradientCfg) {
          gradient.addColorStop(key, gradientCfg[key]);
        }
        legendCtx.fillStyle = gradient;
        legendCtx.fillRect(0, 0, 360, 15);
        gradientImg.src = legendCanvas.toDataURL();
        
      },

      radius: 1, // Adjust the radius as needed
      gradient: {
        // enter n keys between 0 and 1 here
        // for gradient color customization
        // '.1': 'blue',
        '.1': 'green',
        '.2': 'rgb(154, 205, 50)',
        '.4': 'yellow',
        '.7': 'rgb(240, 99, 5)',
        '.9': 'red'

      }
    });

    // Set the data for the heatmap
    this.heatmapInstance.setData({
      max: -50, 
      min: -75, // TODO need to be a variable
      data: this.props.data,
    });
    this.props.handleHeatmapImage(this.heatmapInstance.getDataURL(), this.props.graphId);

  }

  componentDidUpdate(prevProps, prevState, snapshot){
    const { data, graphId } = this.props;
    if(data !== prevProps.data) {
      this.heatmapInstance.setData({
        max: -50, 
        min: -75, // TODO need to be a variable
        data: data,
      });
      this.props.handleHeatmapImage(this.heatmapInstance.getDataURL(), graphId);
    } 
  }

  componentWillUnmount() {
    // Cleanup the heatmap instance when the component unmounts
    if (this.heatmapInstance) {
      this.heatmapInstance = null;
    }
  }

  render() {
    let renderContent;
    if (this.props.shouldDisplay === false){
      renderContent = (
        <>
        <div style={{ display: 'none', width: this.props.width, height: this.props.height, backgroundSize: 'cover' }} ref={this.heatmapRef}/>
        <div style={{ display: 'none', position: 'relative', left: '50%', bottom: '0%', width: '500px', marginLeft: '-180px' }}>
          <br />
          <img id="gradient" alt="heatmap-legend"/>
        </div>
        </>)
    }
    else {
      renderContent = (
        <>
        <div style={{ display: 'none', width: this.props.width, height: this.props.height, backgroundSize: 'cover' }} ref={this.heatmapRef}/>
        <div style={{ position: 'relative', left: '50%', bottom: '0%', width: '500px', marginLeft: '-180px' }}>
          <span style={{ position: 'relative', left: '115px' }}>Strong</span>
          <span style={{ position: 'relative', right: '240px' }}>Weak</span>
          <br />
          <img id="gradient" alt="heatmap-legend"/>
        </div>
        </>)
    }
    return (
        <div> {renderContent} </div>
    )
  }
}

export default RssiHeatMap;